// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3BanU","selected":"Chip_selected__3eaAE"};